import React from "react";

import "../../style/footer.css"
import ConstUtils from "../../config/constants";

export default function Footer(props) {
    const { isFooterFixed } = props;
    return (
        <div className={isFooterFixed ? 'footer-fixed' : 'footer'}>
            <div className="right-content">
                <div>
                    <img src={`${ConstUtils.StaticS3ImageUrl}/MedibuddyLogo.svg`} alt="Medibuddy Self Allocation" />
                    <p className="footer-copyright">Phasorz Technologies Pvt. Ltd. © 2022</p>
                </div>

                <div className="footer-divider-vertical"></div>

                <div>
                    <p className="footer-help-title mb-1">Having trouble booking?</p>
                    <p className="footer-help-contact mb-0">
                        Call us at{" "}
                        <a href="tel:08068239362" className="footer-help-link">
                            080-68239362
                        </a>
                        , 10am to 6pm
                    </p>
                </div>
            </div>

            <div className="footer-links">
                <a target="_blank" href="https://www.medibuddy.in/aboutus/" rel="noopener noreferrer">
                    About us
                </a>
                <span className="footer-divider mx-2">|</span>
                <a target="_blank" href="https://www.medibuddy.in/terms" rel="noopener noreferrer">
                    Terms and conditions
                </a>
                <span className="footer-divider mx-2">|</span>
                <a target="_blank" href="https://www.medibuddy.in/privacy-policy" rel="noopener noreferrer">
                    Privacy policy
                </a>
            </div>
        </div>
    );
}